/// <reference types="google-maps" />

import has from 'lodash/has';
import union from 'lodash/union';

export class Gis {

  id;
  address: google.maps.places.PlaceResult;
  description: string;
  latitude: number;
  longitude: number;
  types = [];
  title: string;

  constructor(place: google.maps.places.PlaceResult | Gis) {
    if (this.predicate<google.maps.places.PlaceResult>(place)) {
      this.id = place['reference'] || place.place_id;
      this.address = place;
      this.description = place.formatted_address;
      this.latitude = place.geometry && place.geometry.location ? place.geometry.location.lat() : undefined;
      this.longitude = place.geometry && place.geometry.location ? place.geometry.location.lng() : undefined;
      place.address_components.forEach((component, key) => {
        if (key === 0) {
          this.title = component.long_name;
        }
        this.types = union(this.types, component.types);
      });
    } else {
      this.id = place.id;
      this.address = place.address;
      this.description = place.description;
      this.latitude = place.latitude || place['lat'];
      this.longitude = place.longitude || place['lng'];
      this.types = place.types;
      this.title = place.title;
    }
  }

  predicate<PlaceType>(place: PlaceType | Gis): place is PlaceType {
    return has(place as PlaceType, 'geometry');
  }

  toString(): string {
    return Array.isArray(this.address)
      ? this.description
      : this.address?.formatted_address || this.address?.['formattedAddress'];
  }

  hasCoords(): boolean {
    return this.latitude !== undefined && this.longitude !== undefined;
  }

  location(): google.maps.LatLng {
    return this.address.geometry.location;
  }

  get locality(): string {
    return this.getAreaLevel('locality');
  }

  get administrativeAreaLevel3(): string {
    return this.getAreaLevel('administrative_area_level_3');
  }

  get administrativeAreaLevel1(): string {
    return this.getAreaLevel('administrative_area_level_1');
  }

  private getAreaLevel(levelName: string): string {
    if (!levelName) {
      return;
    }
    const addressComponent = this.address.address_components || this.address['addressComponents'];
    if (this.address && (addressComponent instanceof Array)) {
      const components = addressComponent as Array<google.maps.GeocoderAddressComponent>;

      const areaLevel = components.find(component => component.types.includes(levelName));

      if (areaLevel) {
        return areaLevel.long_name || areaLevel['longName'];
      }
    }

    return;
  }
}
